import React from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Portofolio', target: 'portofolio' },
  { label: 'Kontak', target: 'kontak' },
  { label: 'Lokasi', target: 'lokasi' },
];

function Navbar() {
  function handleSectionClick(event, target) {
    event.preventDefault();
    document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <header className="site-header">
      <div className="nav-wrap">
        <Link className="wordmark" to="/" aria-label="candradimuka.id cibubur, beranda">
          <span className="brand-mark" aria-hidden="true">C</span>
          <span>candradimuka.id cibubur</span>
        </Link>
        <nav className="desktop-nav" aria-label="Navigasi utama">
          {navLinks.map(({ label, target }) => (
            <a
              key={target}
              href={`#${target}`}
              onClick={(event) => handleSectionClick(event, target)}
            >
              {label}
            </a>
          ))}
        </nav>
        <a
          className="mobile-contact"
          href="https://bit.ly/WACoachYuan"
          target="_blank"
          rel="noopener noreferrer"
        >
          Chat WhatsApp
        </a>
      </div>
    </header>
  );
}

export default Navbar;